export default __webpack_public_path__ + "static/media/deloitte.8143b5a1.svg";